import React, { useEffect, useState } from 'react'
import { ChatAssistant } from '../../types'

export const AssistantContext = React.createContext<ChatAssistant>(null)

export default function useAssistant() {
  return React.useContext(AssistantContext)
}

export function useCurrentAssistant(assistant: ChatAssistant) {
  const [_, refresh] = useState<object>({})

  useEffect(() => {
    if (assistant) {
      if (!assistant.ready) {
        assistant.init().catch(error => {
          // eslint-disable-next-line no-console
          console.error('Failed to initialize assistant:', assistant.id, error)
        })
      }
      const unsubscribe = assistant.listen(() => void refresh({}))

      assistant.chatOpened?.()

      return () => {
        unsubscribe()
        assistant.chatClosed?.()
      }
    }
    return void 0
  }, [assistant])

  return assistant
}

export function useAssistants(assistants: ChatAssistant[]) {
  const [currentAssistant, setCurrentAssistant] = useState<ChatAssistant>(assistants[0])

  useCurrentAssistant(currentAssistant)

  return { currentAssistant, setCurrentAssistant }
}
